const getNetworkStock = (networkStock, limit) => {
  if (!networkStock) {
    return 0;
  }
  const qty = networkStock;
  return limit && qty > limit ? limit : qty;
};

export { getNetworkStock };
